import { render, staticRenderFns } from "./section-money-back-guarantee.vue?vue&type=template&id=3bea18c6&scoped=true&"
import script from "./section-money-back-guarantee.vue?vue&type=script&lang=js&"
export * from "./section-money-back-guarantee.vue?vue&type=script&lang=js&"
import style0 from "./section-money-back-guarantee.vue?vue&type=style&index=0&id=3bea18c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea18c6",
  null
  
)

export default component.exports